/**
 * Shared page_content filter for the update surfaces (SCRUM-643; was
 * duplicated as inline IIFEs in UpdatePageView and as scope-filter effects in
 * HandleContent (both statuses)): keep the entries of one variabletype
 * bucket, narrowed to the variables the template still declares — legacy
 * pages can carry orphaned entries of variables that were removed from the
 * template. An empty template list keeps everything (the legacy tolerance
 * for templates without content_variables). `templateVars` is the template's
 * bucket list.
 */
export function filterTemplateContent<T extends { variable?: string; variabletype?: string }>(
  pageContent: T[] | undefined,
  templateVars: { variable?: string }[] | undefined,
  bucket: "ContentRequired" | "ContentOptional"
): T[] {
  const names = (templateVars ?? []).map((v) => v.variable);
  return (pageContent ?? []).filter(
    (ctn) =>
      ctn.variabletype === bucket &&
      (names.length === 0 || names.includes(ctn.variable))
  );
}
